<div mat-dialog-title class="modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="dialog-header-left">
    <mat-icon>drag_indicator</mat-icon>
    <span id="upload-title" style="color: #1A567A;">{{dialogTitle}}</span>
  </div>
  <div class="dialog-header-right">
    <mat-icon id="close-x" class="dnenialog-title"
	      (click)="close()">close</mat-icon>
  </div>
</div>

<mat-dialog-content class="panel-class" style="margin-top: 1rem;">
    <div class="dialog-message" style="margin-top: 1%; font-size: 0.75rem; color: #1A567A;">{{dialogMessage}}   </div>    
    <mat-form-field class="mat-form-field" appearance="outline"
		    style="width: 100%;" autocomplete="off"
		    >
      <input matInput [(ngModel)]="groupName" [ngModelOptions]="{standalone: true}"
     	  (keyup.enter)='this.save()' 
          placeholder="Untitled group" autocomplete="off">
    </mat-form-field>
    
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="bottom-buttons" id="create-color"
	  (click)='this.save()'>{{dialogBtnTitle}}</button>
  <button mat-raised-button class="bottom-buttons"
	  (click)='this.close()'>Cancel</button>
</mat-dialog-actions>    
